import React from "react";
import { match } from "ts-pattern";
import { Visit } from "../../../../system/AppState/AppVisitsState";
import { PendingConfirmationVisitDatesFlexiblePattern } from "./PendingConfirmationVisitDatesFlexiblePattern";
import { PendingConfirmationVisitDatesPattern } from "./PendingConfirmationVisitDatesPattern";
import { PendingConfirmationVisitDatesSingles } from "./PendingConfirmationVisitDatesSingles";

interface Props {
  visit: Visit.Available;
}

export const PendingConfirmationVisitDates = ({ visit }: Props) =>
  match(visit)
    .with({ publicVisitBroadcastDetails: { type: "Pattern" } }, (v) => (
      <PendingConfirmationVisitDatesPattern visit={v} />
    ))
    .with({ publicVisitBroadcastDetails: { type: "Singles" } }, (v) => (
      <PendingConfirmationVisitDatesSingles visit={v} />
    ))
    .with({ publicVisitBroadcastDetails: { type: "FlexiblePattern" } }, (v) => (
      <PendingConfirmationVisitDatesFlexiblePattern visit={v} />
    ))
    .exhaustive();
